import SevaInformation from './SevaInformation';
export default SevaInformation;
